export default "__VITE_ASSET__DYhEwdkP__"